var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.about)?_c('div',{attrs:{"id":"aboutOuter"}},[_c('div',{attrs:{"id":"about"},domProps:{"innerHTML":_vm._s(_vm.about.text)}}),_c('div',{attrs:{"id":"notice"},domProps:{"innerHTML":_vm._s(_vm.about.smalltext)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }